import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import ScenePanel from "./ScenePanel.js";

const CampaignScene = observer(() => {
  const { t } = useTranslation();
  return (
    <ScenePanel image="/assets/landing/curated-world.webp" alt={t("landing.what.artAlt")} side="right">
      <p className="landing-eyebrow">{t("landing.what.eyebrow")}</p>
      <h2>{t("landing.what.title")}</h2>
      <p>{t("landing.what.body")}</p>
      <p className="landing-scene-statement">{t("landing.what.statement")}</p>
    </ScenePanel>
  );
});

export default CampaignScene;
